/* tslint:disable */
type SexoEnum =
  'FEMININO' |
  'MASCULINO' |
  'OUTROS';
module SexoEnum {
  export const FEMININO: SexoEnum = 'FEMININO';
  export const MASCULINO: SexoEnum = 'MASCULINO';
  export const OUTROS: SexoEnum = 'OUTROS';
  export function values(): SexoEnum[] {
    return [
      FEMININO,
      MASCULINO,
      OUTROS
    ];
  }
}

export { SexoEnum }